export const WALLET_STANDING_STATUSES = ['OK', 'WARN', 'BLOCKED', 'UNGOVERNED'];
export class DriverWalletApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** `GET /v1/driver/wallet` — balance, standing, group, packages and open top-ups. */
    wallet() {
        return this.client.request({ method: 'GET', path: '/v1/driver/wallet', auth: true });
    }
    /** `GET /v1/driver/wallet/statement` — every movement, newest first. */
    statement(limit) {
        const q = limit !== undefined ? `?limit=${encodeURIComponent(String(limit))}` : '';
        return this.client.request({ method: 'GET', path: `/v1/driver/wallet/statement${q}`, auth: true });
    }
    /** `POST /v1/driver/wallet/top-ups` — buy a package; answers the instrument to pay. */
    buy(input) {
        return this.client.request({ method: 'POST', path: '/v1/driver/wallet/top-ups', body: input, auth: true });
    }
    /** `GET /v1/driver/wallet/top-ups/:id` — one top-up; a pending one is re-read at the PSP (and credited when paid). */
    topUp(topUpId) {
        return this.client.request({ method: 'GET', path: `/v1/driver/wallet/top-ups/${encodeURIComponent(topUpId)}`, auth: true });
    }
}
// ---- the Admin -------------------------------------------------------------------------------------------------
export const WALLET_ADJUSTMENT_REASON_CODES = ['CORRECTION', 'GOODWILL', 'CASH_TOP_UP_AT_DESK', 'PSP_PAYMENT_RECONCILED', 'CHARGEBACK'];
const m = (market) => `market=${encodeURIComponent(market)}`;
export class WalletAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    packages(market) {
        return this.client.request({ method: 'GET', path: `/v1/admin/wallet/packages?${m(market)}`, auth: true });
    }
    savePackage(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/wallet/packages', body: input, auth: true });
    }
    wallets(market) {
        return this.client.request({ method: 'GET', path: `/v1/admin/wallet/wallets?${m(market)}`, auth: true });
    }
    wallet(market, driverId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/wallet/wallets/${encodeURIComponent(driverId)}?${m(market)}`, auth: true });
    }
    changes(market, status = 'PENDING') {
        return this.client.request({ method: 'GET', path: `/v1/admin/wallet/changes?${m(market)}&status=${status}`, auth: true });
    }
    proposeAdjustment(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/wallet/adjustments', body: input, auth: true });
    }
    decideAdjustment(adjustmentId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/wallet/adjustments/${encodeURIComponent(adjustmentId)}/decision`, body: input, auth: true });
    }
    proposeCeiling(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/wallet/ceiling-overrides', body: input, auth: true });
    }
    decideCeiling(changeId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/wallet/ceiling-overrides/${encodeURIComponent(changeId)}/decision`, body: input, auth: true });
    }
    groups(market) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-groups?${m(market)}`, auth: true });
    }
    createGroup(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/driver-groups', body: input, auth: true });
    }
    updateGroup(groupId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/driver-groups/${encodeURIComponent(groupId)}`, body: input, auth: true });
    }
    members(market, groupId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-groups/${encodeURIComponent(groupId)}/members?${m(market)}`, auth: true });
    }
    addMember(groupId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/driver-groups/${encodeURIComponent(groupId)}/members`, body: input, auth: true });
    }
    /** `GET /v1/config/integrations/wallet-top-up` — every country's top-up PSP slot (`integration:view`). */
    topUpSlots() {
        return this.client.request({ method: 'GET', path: '/v1/config/integrations/wallet-top-up', auth: true });
    }
    /** `PUT /v1/config/integrations/wallet-top-up/:providerId` — seal the key / token (`integration:manage`). */
    saveTopUpSlot(providerId, input) {
        return this.client.request({ method: 'PUT', path: `/v1/config/integrations/wallet-top-up/${encodeURIComponent(providerId)}`, body: input, auth: true });
    }
    removeMember(market, groupId, driverId) {
        return this.client.request({ method: 'DELETE', path: `/v1/admin/driver-groups/${encodeURIComponent(groupId)}/members/${encodeURIComponent(driverId)}?${m(market)}`, auth: true });
    }
    /** D502 (Q-006): the four-eyes proposals on groups that carry a ceiling of their own (`GET /v1/admin/driver-group-changes`). */
    groupChanges(market, status) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-group-changes?${m(market)}${status !== undefined ? `&status=${status}` : ''}`, auth: true });
    }
    /** D502 (Q-006): apply or reject another operator's proposal — never one's own (the server refuses `SELF_APPROVAL`). */
    decideGroupChange(changeId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/driver-group-changes/${encodeURIComponent(changeId)}/decision`, body: input, auth: true });
    }
}
//# sourceMappingURL=driver-wallet.js.map